import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, apiErr } from "./lib/api";
import { Btn, Input, Label, Modal } from "./ui";

export function ChangePasswordButton() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const reset = () => { setCur(""); setPw(""); setPw2(""); setOpen(false); };
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Password changed. Other sessions signed out.");
      reset();
    } catch (err) { toast.error(apiErr(err)); }
    finally { setBusy(false); }
  };
  return (
    <>
      <Btn data-testid="change-password-btn" variant="ghost" className="w-full mb-1" onClick={() => setOpen(true)}><KeyRound size={16} /> Change password</Btn>
      <Modal open={open} onClose={reset} title="Change password">
        <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
          <div><Label>Current password</Label><Input data-testid="cp-current" type="password" value={cur} onChange={(e) => setCur(e.target.value)} autoComplete="current-password" required /></div>
          <div><Label>New password</Label><Input data-testid="cp-new" type="password" value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" required />
            <p className="text-xs text-slate-500 mt-1">10+ characters with upper, lower, number and symbol.</p></div>
          <div><Label>Confirm new password</Label><Input data-testid="cp-confirm" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" required /></div>
          <div className="flex justify-end gap-2 pt-1">
            <Btn type="button" variant="ghost" onClick={reset}>Cancel</Btn>
            <Btn data-testid="cp-submit" type="submit" disabled={busy}>{busy ? "Saving…" : "Update password"}</Btn>
          </div>
        </form>
      </Modal>
    </>
  );
}
